import React from "react";
import ContainerAdaptavel from "../../../extra-components/container-adaptavel";
import CashbackDetailsView from "./cashback-details-view";
import CashbackValidateSearch from "./cashback-validate-search";
import CashbackUpdateClient from "./cashback-update-client";
import CashbackNew from "./cashback-new";
import CashbackDelete from "./cashback-delete";
import CashbackLegend from "./cashback-legend";

function CashbackModal({ modal }) {
  let body;
  let notAdaptable = false;
  switch (modal.type) {
    case CashbackModal.modal.VIEW:
      body = <CashbackDetailsView id={modal.data.id} />;
      notAdaptable = true;
      break;
    case CashbackModal.modal.VALIDATE_AND_SEARCH:
      body = <CashbackValidateSearch />;
      break;
    case CashbackModal.modal.UPDATE_CLIENT:
      body = <CashbackUpdateClient {...modal.data} />;
      break;
    case CashbackModal.modal.NEW_CASHBACK:
      body = <CashbackNew />;
      break;
    case CashbackModal.modal.DELETE_CASHBACK:
      body = <CashbackDelete id={modal.data.id} />;
      break;
    case CashbackModal.modal.LEGEND_CASHBACK:
      body = <CashbackLegend />;
      break;

    default:
      body = null;
  }

  return notAdaptable ? body : <ContainerAdaptavel>{body}</ContainerAdaptavel>;
}

CashbackModal.modal = {
  VIEW: "VIEW",
  VALIDATE_AND_SEARCH: "VALIDATE_AND_SEARCH",
  UPDATE_CLIENT: "UPDATE_CLIENT",
  NEW_CASHBACK: "NEW_CASHBACK",
  DELETE_CASHBACK: "DELETE_CASHBACK",
  LEGEND_CASHBACK: "LEGEND_CASHBACK",
};

export default CashbackModal;
